import { withNaming } from '@bem-react/classname';

export const classname = withNaming({ n: 'p-', e: '__', m: '--', v: '_' });
